<template>
    <cp-select
        :config="configUsers"
        item-value="id"
        item-text="name"
        clearable
        v-on="$listeners"
        v-bind="attrs"
        :customSelection="true"
        :customItem="true"
    >
        <template v-slot:selection="{ item }">
            {{ `${item.trade_name} - Doc: ${item.document}` }}
        </template>

        <template v-slot:item="{ item, on, attrs }">
            <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                <v-list-item-content>
                    <v-list-item-title>
                        <strong>Razão Social:</strong> {{ item.legal_name }}<br>
                        <strong>Nome Fantasia:</strong> {{ item.trade_name }}<br>
                        <strong>Documento:</strong> {{ item.document }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </template>
    </cp-select>
</template>

<script>

export default {
    props: {
        configUsers: {
            type: Object,
            required: false,
            default: () => { return {route: 'v2.suppliers.json'} },
        },
    },

    computed: {
        attrs() {
            const { label, name, ...attrs } = this.$attrs;

            return { ...{
                label: label || 'Selecione um fornecedor',
                name: name || "select-supplier"
            }, ...attrs };
        },
    },
}
</script>